import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertDate',
})
export class ConvertDatePipe implements PipeTransform {
  transform(value: string): string {
    // return 'null';
    if (value) {
      let v = value.split('-');
      return v[2] + '-' + v[1] + '-' + v[0];
    } else {
      return 'Invalid Date';
    }
  }
}
